import { INDUSTRY_BASED_LICENSE } from "./documents";

export const COMPANY_TYPES = {
  INDIVIDUAL: "perseorangan",
  INDIVIDUAL_COMPANY: "pt_perorangan",
  PT: "pt",
  CV: "cv",
  FOUNDATION: "yayasan",
  BMT: "bmt",
  COOPERATIVE: "koperasi",
  BPR: "bpr",
  BPRS: "bprs",
  BANK: "bank",
  PJP: "pjp",
  FIRM: "firma",
  UNIVERSITY: "perguruan_tinggi",
  MINISTRY: "kementerian",
  GOVERNMENT_AGENCY: "lembaga_pemerintahan",
  GOVERMENT_ENTITIES: "badan_usaha_pemerintah"
};

export const COMPANY_CATEGORIES_MAP = {
  [COMPANY_TYPES.PT]: "common_legal_entity",
  [COMPANY_TYPES.CV]: "common_legal_entity",
  [COMPANY_TYPES.FIRM]: "common_legal_entity",
  [COMPANY_TYPES.MINISTRY]: "ministry_government",
  [COMPANY_TYPES.UNIVERSITY]: "university",
  [COMPANY_TYPES.FOUNDATION]: "foundation",
  [COMPANY_TYPES.INDIVIDUAL]: "individual_msme",
  [COMPANY_TYPES.PJP]: "pjp",
  [COMPANY_TYPES.COOPERATIVE]: "cooperative",
  [COMPANY_TYPES.INDIVIDUAL_COMPANY]: "individual_company",
  [COMPANY_TYPES.BANK]: "bank",
  [COMPANY_TYPES.BMT]: "bmt",
  [COMPANY_TYPES.BPR]: "common_legal_entity",
  [COMPANY_TYPES.BPRS]: "common_legal_entity",
  [COMPANY_TYPES.GOVERMENT_ENTITIES]: "ministry_government",
  [COMPANY_TYPES.GOVERNMENT_AGENCY]: "ministry_government"
};

export const NON_ELIGILBE_BUSINESS_FORM = ["pjp", "bmt", "bpr", "bprs", "bank"];
export const NON_ELIGILBE_INDUSTRIES = [
  24, //Banking
  25, //PPOB
  26, //Insurance & InsurTech
  27, //Payment/Payment Gateway/Remittance
  28, //SME Lending
  29, //Capital Market
  30, //Crypto Exchange
  31, //Koperasi Simpan Pinjam
  32 // Koperasi Simpan Pinjam Syariah
];

export const ENTITIES_LICENSE_LIST = [
  COMPANY_TYPES.FOUNDATION,
  COMPANY_TYPES.BMT,
  COMPANY_TYPES.COOPERATIVE,
  COMPANY_TYPES.BANK,
  COMPANY_TYPES.PJP,
  COMPANY_TYPES.UNIVERSITY,
  COMPANY_TYPES.MINISTRY,
  COMPANY_TYPES.GOVERMENT_ENTITIES,
  COMPANY_TYPES.GOVERNMENT_AGENCY
];

export const INDUSTRY_LICENSE_LIST = {
  AGRICULTURE: "81",
  BEAUTY_PRODUCTS: "85",
  CABLE_STREAMING_SERVICE: "88",
  COLLEGE_SCHOOLS: "90",
  DRUG_STORES_PHARMACIES: "93",
  EDUCATION_SERVICES: "94",
  FINANCIAL_SERVICES_MULTIFINANCE: "98",
  FINANCIAL_SERVICES_BANKING_CONVENTIONAL_DIGITAL: "99",
  FINANCIAL_SERVICES_LENDING: "100",
  FINANCIAL_SERVICES_CROWDFUNDING: "101",
  FINANCIAL_SERVICES_KOPERASI: "102",
  FINANCIAL_SERVICES_MONEY_CHANGER: "103",
  FINANCIAL_SERVICES_PAYMENT_GATEWAY_PJP_1_2: "104",
  FINANCIAL_SERVICES_REMITTANCE_PJP_3: "105",
  FOOD_AND_BEVERAGES: "107",
  HOTEL_RESORTS_HOSPITALITY: "114",
  FINANCIAL_SERVICES_INSURANCE: "115",
  FINANCIAL_SERVICES_INVESTMENT: "116",
  MARKETPLACE: "120",
  MEDICAL_SERVICES: "121",
  MEDICAL_SUPPLIES_EQUIPMENT: "122",
  SHIPPING_AND_DELIVERY_SERVICE: "131",
  TRANSPORTATION: "135",
  WEB_APP_DEVELOPER_HOSTING: "138"
};

export const INDUSTRY_ROLLOUT_HAS_NO_LICENSE = {
  CONSULTING: "91",
  DIGITAL_CONTENT: "92",
  DRUG_STORES_PHARMACIES: "93",
  SOFTWARE: "132",
  SPORTS: "133"
};

export const ROLLOUT_INDUSTRY_LIST = [
  ...Object.values(INDUSTRY_LICENSE_LIST),
  ...Object.values(INDUSTRY_ROLLOUT_HAS_NO_LICENSE)
];

// will not show if the doc same with entity based license (entity = bank)
export const MAPPING_INDUSTRY_WITH_ENTITY_BANK = {
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_MULTIFINANCE]: [INDUSTRY_BASED_LICENSE.OJK_LICENSE], // will not show if the doc same with entity based license
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_BANKING_CONVENTIONAL_DIGITAL]: [INDUSTRY_BASED_LICENSE.OJK_LICENSE], // will not show if the doc same with entity based license
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_LENDING]: [INDUSTRY_BASED_LICENSE.OJK_LICENSE], // will not show if the doc same with entity based license
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_CROWDFUNDING]: [INDUSTRY_BASED_LICENSE.OJK_LICENSE], // will not show if the doc same with entity based license
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_INSURANCE]: [INDUSTRY_BASED_LICENSE.OJK_LICENSE] // will not show if the doc same with entity based license
};
// will not show if the doc same with entity based license (entity = pjp)
export const MAPPING_INDUSTRY_WITH_ENTITY_PJP = {
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_MONEY_CHANGER]: [INDUSTRY_BASED_LICENSE.BI_LICENSE], // will not show if the doc same with entity based license
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_PAYMENT_GATEWAY_PJP_1_2]: [INDUSTRY_BASED_LICENSE.BI_LICENSE], // will not show if the doc same with entity based license
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_REMITTANCE_PJP_3]: [INDUSTRY_BASED_LICENSE.BI_LICENSE] // will not show if the doc same with entity based license
};

export const MAPPING_INDUSTRY_WITH_TWO_LICENSE = {
  [INDUSTRY_LICENSE_LIST.CABLE_STREAMING_SERVICE]: [
    INDUSTRY_BASED_LICENSE.IPP,
    INDUSTRY_BASED_LICENSE.SERTIFIKASI_PERANGKAT_TELKOM
  ],
  [INDUSTRY_LICENSE_LIST.DRUG_STORES_PHARMACIES]: [
    INDUSTRY_BASED_LICENSE.PHARMACY_LICENSE,
    INDUSTRY_BASED_LICENSE.BPOM_CIRCULATION_LICENSE
  ],
  [INDUSTRY_LICENSE_LIST.MARKETPLACE]: [INDUSTRY_BASED_LICENSE.SIUPMSE, INDUSTRY_BASED_LICENSE.TDPSE],
  [INDUSTRY_LICENSE_LIST.MEDICAL_SUPPLIES_EQUIPMENT]: [
    INDUSTRY_BASED_LICENSE.MEDICAL_EQUIPMENT_DISTRIBUTION_LICENSE,
    INDUSTRY_BASED_LICENSE.SERTIFIKAT_PRODUKSI_ALAT_KESEHATAN
  ]
};

export const MAPPING_ONE_INDUSTRY_CONDITIONAL_LICENSE = {
  [INDUSTRY_LICENSE_LIST.AGRICULTURE]: { [INDUSTRY_BASED_LICENSE.PSAT_PD]: "psat-pd.optional" },
  [INDUSTRY_LICENSE_LIST.BEAUTY_PRODUCTS]: {
    [INDUSTRY_BASED_LICENSE.BPOM_CIRCULATION_LICENSE]: "bpom-circulation-license.optional.85"
  },
  [INDUSTRY_LICENSE_LIST.COLLEGE_SCHOOLS]: {
    [INDUSTRY_BASED_LICENSE.OPERATIONAL_LICENSE_CITY_GOV]: "operational-license-city-gov.optional"
  },
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_KOPERASI]: {
    [INDUSTRY_BASED_LICENSE.COOPERATIVE_BUSINESS_LICENSE_OJK]: "cooperative-business-license-ojk.optional"
  },
  [INDUSTRY_LICENSE_LIST.FOOD_AND_BEVERAGES]: {
    [INDUSTRY_BASED_LICENSE.BPOM_CIRCULATION_LICENSE]: "bpom-circulation-license.optional.107"
  }
};

export const MAPPING_INDUSTRY_WITH_CONDITIONAL_LICENSE = {
  [INDUSTRY_LICENSE_LIST.CABLE_STREAMING_SERVICE]: {
    [INDUSTRY_BASED_LICENSE.SERTIFIKASI_PERANGKAT_TELKOM]: "sertifikasi-perangkat-telkom.optional"
  },
  [INDUSTRY_LICENSE_LIST.DRUG_STORES_PHARMACIES]: {
    [INDUSTRY_BASED_LICENSE.BPOM_CIRCULATION_LICENSE]: "bpom-circulation-license.optional.93"
  },
  [INDUSTRY_LICENSE_LIST.MEDICAL_SUPPLIES_EQUIPMENT]: {
    [INDUSTRY_BASED_LICENSE.SERTIFIKAT_PRODUKSI_ALAT_KESEHATAN]: "sertifikat-produksi-alat-kesehatan.optional"
  },
  ...MAPPING_ONE_INDUSTRY_CONDITIONAL_LICENSE
};

export const MAPPING_INDUSTRY_LICENSE = {
  [INDUSTRY_LICENSE_LIST.AGRICULTURE]: [INDUSTRY_BASED_LICENSE.PSAT_PD],
  [INDUSTRY_LICENSE_LIST.BEAUTY_PRODUCTS]: [INDUSTRY_BASED_LICENSE.BPOM_CIRCULATION_LICENSE],
  [INDUSTRY_LICENSE_LIST.COLLEGE_SCHOOLS]: [INDUSTRY_BASED_LICENSE.OPERATIONAL_LICENSE_CITY_GOV],
  [INDUSTRY_LICENSE_LIST.EDUCATION_SERVICES]: [INDUSTRY_BASED_LICENSE.OPERATIONAL_LICENSE_CITY_GOV],
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_KOPERASI]: [INDUSTRY_BASED_LICENSE.COOPERATIVE_BUSINESS_LICENSE_OJK],
  [INDUSTRY_LICENSE_LIST.FOOD_AND_BEVERAGES]: [INDUSTRY_BASED_LICENSE.BPOM_CIRCULATION_LICENSE],
  [INDUSTRY_LICENSE_LIST.HOTEL_RESORTS_HOSPITALITY]: [INDUSTRY_BASED_LICENSE.OPERATIONAL_LICENSE_MINISTRY_TOURISM],
  [INDUSTRY_LICENSE_LIST.FINANCIAL_SERVICES_INVESTMENT]: [INDUSTRY_BASED_LICENSE.BAPPEBTI_LICENSE],
  [INDUSTRY_LICENSE_LIST.MEDICAL_SERVICES]: [INDUSTRY_BASED_LICENSE.OPERATIONAL_LICENSE_FROM_DINKES],
  [INDUSTRY_LICENSE_LIST.SHIPPING_AND_DELIVERY_SERVICE]: [INDUSTRY_BASED_LICENSE.BUSINESS_LICENSE_FROM_KEMENHUB],
  [INDUSTRY_LICENSE_LIST.TRANSPORTATION]: [INDUSTRY_BASED_LICENSE.BUSINESS_LICENSE_FROM_KEMENHUB],
  [INDUSTRY_LICENSE_LIST.WEB_APP_DEVELOPER_HOSTING]: [INDUSTRY_BASED_LICENSE.TDPSE],
  ...MAPPING_INDUSTRY_WITH_ENTITY_BANK,
  ...MAPPING_INDUSTRY_WITH_ENTITY_PJP,
  ...MAPPING_INDUSTRY_WITH_TWO_LICENSE
};
